export const shouldDisplayCaloriesInfo = (
  brandCaloriesEnabled: boolean | undefined,
  userCaloriesEnabled: boolean | undefined
) => !!(brandCaloriesEnabled && userCaloriesEnabled);

export const shouldDisplayItemCalories = (
  brandCaloriesEnabled: boolean | undefined,
  userCaloriesEnabled: boolean | undefined,
  itemHasCalories: boolean | undefined
) => !!(brandCaloriesEnabled && userCaloriesEnabled && itemHasCalories);
